# A request's fields, plus the extra views of the design for its package
# (PackageViews in customizer/js/common.js, or the customizer's own
# configurator.package_views): then it goes as a multipart upload, the views
# as JPEG (or PNG) files view_<name>. A failed capture only leaves the views out.
# File-level so both the sign-off and the request-sign-off handlers can use it.
withPackageViews = (data) ->
    views = []
    try
        if configurator.package_views
            views = configurator.package_views()
        else if window.PackageViews
            views = window.PackageViews.capture(configurator)
    catch error
        console.log('Package views left out: ' + error)
    return {data: data} unless views and views.length
    formData = new FormData()
    formData.append(key, value) for own key, value of data
    for view in views
        extension = if view.blob.type is 'image/png' then '.png' else '.jpg'
        formData.append('view_' + view.name, view.blob, view.name + extension)
    {data: formData, processData: false, contentType: false}

@.modalCustomizerSignoffHandler = ->
    $(document).ready(() ->
        # Load fields when user clicks on "Generate Sign-off Drawing" option
        $('.jsModalCustomizerGenerateSignoff').on('click', () ->
            # Reset the form state when opening the signoff panel
            resetSignoffFormState()
            loadSignoffFields()
        )

        # Attach validation to email field on page load
        $(".jsModalCustomizerSignoffInput").on("keyup change", validateSignoffForm)

        generateSignoffDrawing()
    )

    # Reset the signoff form to allow new submissions
    resetSignoffFormState = ->
        signoffDesc = $('.jsModalCustomizerSignoff').find('.jsModalCustomizerDesc')
        # Show the form elements, hide the "sent" confirmation
        signoffDesc.children().show()
        signoffDesc.children('.jsModalCustomizerSignoffGenerated').hide()
        # Re-enable the button (validation will disable if needed)
        validateSignoffForm()

    # Load sign-off fields dynamically based on customizer type
    loadSignoffFields = ->
        customizerName = window.configurator?.serialize?().module_name
        console.log('Loading sign-off fields for customizer:', customizerName)

        if !customizerName
            console.log('No customizer name found')
            return

        # Fetch sign-off fields configuration from backend
        $.ajax({
            type: 'GET'
            url: '/configurator/signoff-fields/' + customizerName + '/'
            success: (data) ->
                console.log('Sign-off fields response:', data)
                if data.success
                    renderSignoffFields(data.fields)
                else
                    console.log('Sign-off not available for this customizer')
            error: (data) ->
                console.log('Failed to load sign-off field configuration:', data)
        })

    # Render sign-off fields from backend configuration
    renderSignoffFields = (fields) ->
        console.log('Rendering sign-off fields:', fields)
        container = $('#signoff-fields-container')
        container.empty()

        # Fields are now provided by the backend API
        if !fields || fields.length == 0
            console.log('No sign-off fields available')
            return

        console.log('Creating HTML for', fields.length, 'fields')
        for field in fields
            fieldHtml = createFieldHtml(field)
            container.append(fieldHtml)

        console.log('Sign-off fields rendered successfully')

        # Attach validation to dynamically created fields
        attachFieldValidation()

    # Create HTML for a single field
    createFieldHtml = (field) ->
        requiredAttr = if field.required then 'required' else ''
        requiredClass = if field.required then 'required' else ''
        requiredLabel = if field.required then ' *' else ''

        if field.type == 'textarea'
            html = """
                <label for="signoff-#{field.name}" class="customizer-options__item__desc__form__label #{requiredClass}">
                    #{field.label}#{requiredLabel}
                    <textarea
                        id="signoff-#{field.name}"
                        name="#{field.name}"
                        class="customizer-options__item__desc__form__input jsModalCustomizerSignoffField"
                        placeholder="#{field.placeholder}"
                        data-required="#{field.required}"
                        #{requiredAttr}
                        rows="3"></textarea>
                </label>
            """
        else
            inputType = field.type || 'text'
            minAttr = if inputType == 'number' then 'min="1"' else ''
            valueAttr = if field.default? then "value=\"#{field.default}\"" else ''
            html = """
                <label for="signoff-#{field.name}" class="customizer-options__item__desc__form__label #{requiredClass}">
                    #{field.label}#{requiredLabel}
                    <input
                        type="#{inputType}"
                        id="signoff-#{field.name}"
                        name="#{field.name}"
                        class="customizer-options__item__desc__form__input jsModalCustomizerSignoffField"
                        placeholder="#{field.placeholder}"
                        data-required="#{field.required}"
                        #{minAttr}
                        #{valueAttr}
                        #{requiredAttr}>
                </label>
            """

        return html

    # Email validation
    validateEmail = (email) ->
        re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        re.test(email)

    # Validate sign-off form
    validateSignoffForm = ->
        generateBtn = $(".jsModalCustomizerSignoffBtn")
        email = $(".jsModalCustomizerSignoffInput").val()

        # Check required fields
        allValid = true

        # Validate email
        if !validateEmail(email)
            allValid = false

        # Validate required sign-off fields
        $('.jsModalCustomizerSignoffField[data-required="true"]').each(() ->
            if !$(this).val() || $(this).val().trim() == ''
                allValid = false
        )

        # Validate number fields are >= 1
        $('.jsModalCustomizerSignoffField[type="number"]').each(() ->
            val = parseInt($(this).val(), 10)
            if isNaN(val) || val < 1
                allValid = false
        )

        if allValid
            generateBtn.removeAttr('disabled')
        else
            generateBtn.attr('disabled', true)

        return allValid

    # Attach validation to form inputs (called after fields are created)
    attachFieldValidation = ->
        # Use event delegation for dynamically created fields
        # Attach to email field
        $(".jsModalCustomizerSignoffInput").off("keyup change").on("keyup change", validateSignoffForm)

        # Attach to all sign-off fields (use event delegation on container)
        $('#signoff-fields-container').off("keyup change", ".jsModalCustomizerSignoffField").on("keyup change", ".jsModalCustomizerSignoffField", validateSignoffForm)

        console.log('Field validation attached')

        # Run initial validation
        validateSignoffForm()

    getCookie = (name) ->
        cookieValue = null
        if document.cookie and document.cookie != ''
            cookies = document.cookie.split(';')
            i = 0
            while i < cookies.length
                cookie = jQuery.trim(cookies[i])
                if cookie.substring(0, name.length + 1) == name + '='
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                    break
                i++
        cookieValue

    generateSignoffDrawing = ->
        customizerSignoff = $('.jsModalCustomizerSignoff')
        customizerDesc = customizerSignoff.find('.jsModalCustomizerDesc')

        # Remove any existing handlers to prevent duplicate submissions
        $('.jsModalCustomizerSignoffBtn').off('click').on('click', (e) ->
            e.preventDefault()

            if !validateSignoffForm()
                return false

            # Disable button immediately to prevent double-clicks
            $(this).attr('disabled', true)

            productId = $('#modalProductId').val()
            customizerData = JSON.stringify(configurator.serialize())
            customizerName = configurator.serialize().module_name
            email = $(".jsModalCustomizerSignoffInput").val()

            # Collect sign-off metadata
            signoffData = {}
            $('.jsModalCustomizerSignoffField').each(() ->
                fieldName = $(this).attr('name')
                fieldValue = $(this).val()
                signoffData['signoff_' + fieldName] = fieldValue
            )

            # Prepare AJAX data
            ajaxData = {
                'productId': productId,
                'customizerData': customizerData,
                'customizerName': customizerName,
                'pdfData': JSON.stringify(configurator.get_pdf_data()),
                'email': email
            }

            # Add sign-off fields to AJAX data
            $.extend(ajaxData, signoffData)
            request = withPackageViews(ajaxData)

            $.ajax({
                type: 'POST'
                url: '/configurator/signoff/'
                data: request.data
                processData: request.processData
                contentType: request.contentType
                success: (data) ->
                    if data.success
                        customizerDesc.children().hide()
                        customizerDesc.children('.jsModalCustomizerSignoffGenerated').show()
                        customizerSignoff.find('.jsModalCustomizerOptionTitle')
                        validateSignoffForm()
                    else
                        # Show error message
                        errorMsg = data.error || 'An error occurred'
                        if data.form_errors
                            errorMsg += ': ' + JSON.stringify(data.form_errors)
                        alert('Error generating sign-off drawing: ' + errorMsg)
                        console.log('Sign-off generation error:', data)
                        # Re-enable button on error so user can retry
                        $('.jsModalCustomizerSignoffBtn').removeAttr('disabled')
                error: (data) ->
                    console.log('Sign-off generation failure:', data)
                    alert('Failed to generate sign-off drawing. Please try again.')
                    # Re-enable button on error so user can retry
                    $('.jsModalCustomizerSignoffBtn').removeAttr('disabled')
                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

modalCustomizerSignoffHandler()


@.modalCustomizerRequestSignoffHandler = ->
    $(document).ready(() ->
        $('.jsModalCustomizerOpenRequestSignoff').on('click', () ->
            resetRequestSignoffFormState()
            loadRequestSignoffFields()
        )
        $(".jsModalCustomizerRequestSignoffEmail").on("keyup change", validateRequestSignoffForm)
        generateRequestSignoffDrawing()
    )

    resetRequestSignoffFormState = ->
        requestSignoffDesc = $('.jsModalCustomizerRequestSignoff').find('.jsModalCustomizerDesc')
        requestSignoffDesc.children().show()
        requestSignoffDesc.children('.jsModalCustomizerRequestSignoffSent').hide()
        validateRequestSignoffForm()

    loadRequestSignoffFields = ->
        customizerName = window.configurator?.serialize?().module_name
        if !customizerName
            return
        $.ajax({
            type: 'GET'
            url: '/configurator/signoff-fields/' + customizerName + '/'
            success: (data) ->
                if data.success
                    renderRequestSignoffFields(data.fields)
            error: (data) ->
                console.log('Failed to load request sign-off field configuration:', data)
        })

    renderRequestSignoffFields = (fields) ->
        container = $('#signoff-request-fields-container')
        container.empty()
        if !fields || fields.length == 0
            return
        for field in fields
            fieldHtml = createRequestSignoffFieldHtml(field)
            container.append(fieldHtml)
        attachRequestFieldValidation()

    createRequestSignoffFieldHtml = (field) ->
        requiredAttr = if field.required then 'required' else ''
        requiredClass = if field.required then 'required' else ''
        requiredLabel = if field.required then ' *' else ''

        if field.type == 'textarea'
            html = """
                <label for="req-signoff-#{field.name}" class="customizer-options__item__desc__form__label #{requiredClass}">
                    #{field.label}#{requiredLabel}
                    <textarea
                        id="req-signoff-#{field.name}"
                        name="#{field.name}"
                        class="customizer-options__item__desc__form__input jsModalCustomizerRequestSignoffField"
                        placeholder="#{field.placeholder}"
                        data-required="#{field.required}"
                        #{requiredAttr}
                        rows="3"></textarea>
                </label>
            """
        else
            inputType = field.type || 'text'
            minAttr = if inputType == 'number' then 'min="1"' else ''
            valueAttr = if field.default? then "value=\"#{field.default}\"" else ''
            html = """
                <label for="req-signoff-#{field.name}" class="customizer-options__item__desc__form__label #{requiredClass}">
                    #{field.label}#{requiredLabel}
                    <input
                        type="#{inputType}"
                        id="req-signoff-#{field.name}"
                        name="#{field.name}"
                        class="customizer-options__item__desc__form__input jsModalCustomizerRequestSignoffField"
                        placeholder="#{field.placeholder}"
                        data-required="#{field.required}"
                        #{minAttr}
                        #{valueAttr}
                        #{requiredAttr}>
                </label>
            """
        return html

    validateRequestSignoffForm = ->
        generateBtn = $(".jsModalCustomizerRequestSignoffBtn")
        email = $(".jsModalCustomizerRequestSignoffEmail").val()
        allValid = true
        re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        if !re.test(email)
            allValid = false
        $('.jsModalCustomizerRequestSignoffField[data-required="true"]').each(() ->
            if !$(this).val() || $(this).val().trim() == ''
                allValid = false
        )
        $('.jsModalCustomizerRequestSignoffField[type="number"]').each(() ->
            val = parseInt($(this).val(), 10)
            if isNaN(val) || val < 1
                allValid = false
        )
        if allValid
            generateBtn.removeAttr('disabled')
        else
            generateBtn.attr('disabled', true)
        return allValid

    attachRequestFieldValidation = ->
        $(".jsModalCustomizerRequestSignoffEmail").off("keyup change").on("keyup change", validateRequestSignoffForm)
        $('#signoff-request-fields-container').off("keyup change", ".jsModalCustomizerRequestSignoffField").on("keyup change", ".jsModalCustomizerRequestSignoffField", validateRequestSignoffForm)
        validateRequestSignoffForm()

    getCookie = (name) ->
        cookieValue = null
        if document.cookie and document.cookie != ''
            cookies = document.cookie.split(';')
            i = 0
            while i < cookies.length
                cookie = jQuery.trim(cookies[i])
                if cookie.substring(0, name.length + 1) == name + '='
                    cookieValue = decodeURIComponent(cookie.substring(name.length + 1))
                    break
                i++
        cookieValue

    generateRequestSignoffDrawing = ->
        customizerRequestSignoff = $('.jsModalCustomizerRequestSignoff')
        customizerDesc = customizerRequestSignoff.find('.jsModalCustomizerDesc')

        $('.jsModalCustomizerRequestSignoffBtn').off('click').on('click', (e) ->
            e.preventDefault()
            if !validateRequestSignoffForm()
                return false
            $(this).attr('disabled', true)

            productId = $('#modalProductId').val()
            customizerData = JSON.stringify(configurator.serialize())
            customizerName = configurator.serialize().module_name
            email = $(".jsModalCustomizerRequestSignoffEmail").val()

            signoffData = {}
            $('.jsModalCustomizerRequestSignoffField').each(() ->
                fieldName = $(this).attr('name')
                fieldValue = $(this).val()
                signoffData['signoff_' + fieldName] = fieldValue
            )

            ajaxData = {
                'productId': productId,
                'customizerData': customizerData,
                'customizerName': customizerName,
                'pdfData': JSON.stringify(configurator.get_pdf_data()),
                'email': email
            }
            $.extend(ajaxData, signoffData)
            request = withPackageViews(ajaxData)

            $.ajax({
                type: 'POST'
                url: '/configurator/signoff/'
                data: request.data
                processData: request.processData
                contentType: request.contentType
                success: (data) ->
                    if data.success
                        customizerDesc.children().hide()
                        customizerDesc.children('.jsModalCustomizerRequestSignoffSent').show()
                    else
                        errorMsg = data.error || 'An error occurred'
                        if data.form_errors
                            errorMsg += ': ' + JSON.stringify(data.form_errors)
                        alert('Error submitting sign-off request: ' + errorMsg)
                        $('.jsModalCustomizerRequestSignoffBtn').removeAttr('disabled')
                error: (data) ->
                    console.log('Request sign-off submission failure:', data)
                    alert('Failed to submit sign-off request. Please try again.')
                    $('.jsModalCustomizerRequestSignoffBtn').removeAttr('disabled')
                headers: {
                    'X-CSRFToken': getCookie('csrftoken')
                }
            })
        )

modalCustomizerRequestSignoffHandler()

